import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { returnEntry } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const returnEntrySlice = createSlice({
    name: returnEntry,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetail: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetail } = returnEntrySlice.actions;
export default returnEntrySlice.reducer;
